
import { settingConfigs } from '../../configurations';
import { STORAGE_KEY } from '../../constants/storage.key';
import { PARAMS as rqParams } from '../../constants/params';
import {
  APP_LANGUAGE_SUPPORTS as languages,
  APP_THEME_SUPPORTS as themes,
  APP_SETTING_ACTION as types,
  APP_STOCK_SETTING
} from '../../constants/app'
import { getSafeStorage, saveSafeStorage, getDeviceInfo as getDevices, getCompanyAndMarketInformation, setHtmlLanguage,isMobile } from '../../helpers/global';
import messages_en from '../../assets/languages/en.json'
import messages_vi from '../../assets/languages/vi.json'
import messages_cn from '../../assets/languages/cn.json'
import messages_hk from '../../assets/languages/hk.json';
import { winVestGetRegion, winVestSwitchLanguage } from '../../services/win-vest-services';
import { store } from '../../configurations';
import { Converter , Filter} from '../../helpers/functions';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { USER_ACTION } from '@/constants/user';
import { I_TRADE_ACTION } from '@/constants/i-trade';
import { getCashAccount } from '@/actions/trading'

const messages_en_extra = require(`@/companys/${iTradeEnv.company}/assets/languages/en.json`)
const messages_vi_extra = require(`@/companys/${iTradeEnv.company}/assets/languages/vi.json`)
const messages_cn_extra = require(`@/companys/${iTradeEnv.company}/assets/languages/cn.json`)
const messages_hk_extra = require(`@/companys/${iTradeEnv.company}/assets/languages/hk.json`)

export const lang_messages = {
  en: Object.assign(messages_en, messages_en_extra),
  vi: Object.assign(messages_vi, messages_vi_extra),
  hans: Object.assign(messages_cn, messages_cn_extra),
  hant: Object.assign(messages_hk, messages_hk_extra)
}

export const switchAccount = (tAccount) => {
  saveSafeStorage(STORAGE_KEY.T_ACCOUNT, JSON.stringify(tAccount[0].tradingAccSeq));
  return (dispatch,getState) => {
    let ctradeAccount = Filter.filterCurrentSubAccount(getState().trade.tradingAccounts,getSafeStorage(STORAGE_KEY.T_ACCOUNT))
    dispatch({
      type: I_TRADE_ACTION.SWITCH_TRADING_ACCOUNT,
      currentTradingAccount: tAccount[0],
      clientID: tAccount[0].clientID
    })
    dispatch({
      type: I_TRADE_ACTION.GET_TRADING_ACCOUNT,
      tradingAccounts: ctradeAccount,
    })
    if (iTradeEnv?.actions?.trading?.getCashAccount) {
      dispatch(getCashAccount())
    }
  }
}

export const switchLanguage = (lang, id) => {
  saveSafeStorage(STORAGE_KEY.LANGUAGE, JSON.stringify(lang));
  if (id) {
    let params = {
      id: id,
      language: Converter.mappingWinVestLanguage(lang.id)
    }
    winVestSwitchLanguage(params)
  }
  const language = lang_messages[lang.value]
  setHtmlLanguage(language.lang)
  return dispatch => {
    dispatch({
      type: types.SWITCH_LANGUAGE,
      language
    })
  }
}

export const saveWinVestUserLanguage = (userInfo) => {
  return (dispatch, getState) => {
    if (userInfo.user_pref && userInfo.user_pref.language) {
      const lang = languages.filter(language => Converter.mappingWinVestLanguage(language.id) === userInfo.user_pref.language)[0]
      saveSafeStorage(STORAGE_KEY.LANGUAGE, JSON.stringify(lang))
      dispatch({ type: types.SWITCH_LANGUAGE, language: lang_messages[lang.value] })
    }
  }
}

export const switchTheme = (theme) => {
  let themeSwitch = themes.filter(e => e !== theme)[0];
  const stockSetting = store.getState().app.stockSetting;
  const stockTheme = `${themeSwitch}-${stockSetting === APP_STOCK_SETTING.RED_RISE_GREEN_FALL ? 'red-rise' : 'green-rise'}`
  document.body.setAttribute('stock-theme', stockTheme);
  saveSafeStorage(STORAGE_KEY.THEME, JSON.stringify(themeSwitch));
  return dispatch => {
    dispatch({
      type: types.SWITCH_THEME,
      theme: themeSwitch,
      appConfiguration: getCompanyAndMarketInformation(iTradeEnv, themeSwitch)
    })
  }
}

export const getWebSetting = () => {
  let appConfiguration = {};
  let savedLanguageCode = '';
  let savedLanguageObj = getSafeStorage(STORAGE_KEY.LANGUAGE);
  if (savedLanguageObj) {
    savedLanguageObj = JSON.parse(savedLanguageObj)
    savedLanguageCode = savedLanguageObj.value
  }
  let savedLanguage = languages.filter(e => e.value === savedLanguageCode);
  let savedTheme = getSafeStorage(STORAGE_KEY.THEME);
  try {
    if (savedTheme) {
      savedTheme = JSON.parse(savedTheme);
    }

    else {
      savedTheme = settingConfigs.theme;
      saveSafeStorage(STORAGE_KEY.THEME, JSON.stringify(savedTheme))
    }

  }
  catch (e) {
    savedTheme = themes[0];
  }
  if (savedLanguage.length > 0) {
    saveSafeStorage(STORAGE_KEY.LANGUAGE, JSON.stringify(savedLanguage[0]));
  } else {
    if (iTradeEnv.defaultLanguage) {
      const firstLanguage = languages.find(v => v.id === iTradeEnv.defaultLanguage)
      if (firstLanguage) {
        savedLanguage = [firstLanguage]
      } else {
        saveSafeStorage(STORAGE_KEY.LANGUAGE, JSON.stringify(languages.filter(e => e.value === settingConfigs.language)[0]));
      }
    } else {
      saveSafeStorage(STORAGE_KEY.LANGUAGE, JSON.stringify(languages.filter(e => e.value === settingConfigs.language)[0]));
    }
  }
  savedLanguage = savedLanguage.length > 0 ? lang_messages[savedLanguage[0].value] : lang_messages[settingConfigs.language]
  setHtmlLanguage(savedLanguage.lang)
  appConfiguration = getCompanyAndMarketInformation(iTradeEnv, savedTheme);
  const stockSetting = store.getState().app.stockSetting;
  const stockTheme = `${savedTheme}-${stockSetting === APP_STOCK_SETTING.RED_RISE_GREEN_FALL ? 'red-rise' : 'green-rise'}`
  document.body.setAttribute('stock-theme', stockTheme);
  document.body.setAttribute("run-mode", isMobile() ? "mobile" : "pc");
  return (dispatch, getState) => {
    const { fontSizeMagnification } = getState().app.accessibility
    if (fontSizeMagnification > 1) {
      document.documentElement.style.setProperty('--mul', fontSizeMagnification)
    }

    dispatch({
      type: types.GET_APP_SETTING,
      language: savedLanguage,
      theme: savedTheme,
      appConfiguration: appConfiguration
    })
  }
}

export const getDeviceInfo = (isMobile, browser, geolocationCall) => {

  return dispatch => {
    dispatch({
      type: types.DETECT_DEVICE,
      isMobile: isMobile,
      browser: browser,
      geolocationCall: geolocationCall
    })
  }
}

export const toggleQuote = (isQuoteValue) => {

  saveSafeStorage(STORAGE_KEY.QUOTE, JSON.stringify(isQuoteValue));
  return dispatch => {
    dispatch({
      type: types.TOGGLE_QUOTE,
      isQuote: isQuoteValue
    })
  }
}

export const switchStockSetting = (settingOption) => {
  const theme = store.getState().app.theme;
  const defaultStockSetting = 'rise-green,fall-red'
  const prefsObject = settingOption && typeof settingOption === 'object' && settingOption['theme-color.up-indicator']
  if (prefsObject) {
    settingOption = settingOption['theme-color.up-indicator'] + ',' + settingOption['theme-color.down-indicator']
  } else if (settingOption === '' || settingOption === undefined || settingOption === null) {
    settingOption = defaultStockSetting
  }
  const stockTheme = `${theme}-${settingOption === APP_STOCK_SETTING.RED_RISE_GREEN_FALL ? 'red-rise' : 'green-rise'}`
  document.body.setAttribute('stock-theme', stockTheme);
  saveSafeStorage(STORAGE_KEY.STOCK_SETTING, JSON.stringify(settingOption));
  return dispatch => {
    dispatch({
      type: types.SWITCH_STOCK_SETTING,
      stockSetting: settingOption
    })
  }
}

export const switchMenuControl = (menuCtrl) => {
  return dispatch => {
    dispatch({
      type: types.SWITCH_MENU_CONTROL,
      menuCtrl: menuCtrl
    })
  }
}

export const toastsAction = (p, isDestroy) => {
  const toast = {
    type: p.type,
    autoClose: true,
    errorCode: p.errorCode,
    isOpen: false
  }
  return dispatch => {
    dispatch({
      type: types.SHOW_TOAST,
      toast: isDestroy ? null : toast
    })
  }
}

export const setAccessibility = (params) => {
  return dispatch => {
    dispatch({
      type: types.SET_ACCESSIBILITY,
      ...params
    })
    saveSafeStorage(STORAGE_KEY.ACCESSIBILITY, JSON.stringify(params))
  }
}

export const updateWithdrawal = (needWithdrawal) => {
  return dispatch => {
    dispatch({
      type: types.UPDATE_WITHDRAWAL,
      needWithdrawal: needWithdrawal
    })
  }
}